<template>
    <div :class="{'form-floating': !simple}">
        <v-select :taggable="taggable" @listener :class="[background]" :disabled="disabled ?? false"
                  :placeholder="placeholder || trans('general.defaults.type_to_search')"
                  v-model="model" v-on="$listeners" :filterable="false" :options="options">
        </v-select>
        <label v-if="!simple"> {{ label || trans('general.defaults.type_to_search') }}</label>
    </div>
</template>

<script>
import vSelect from "vue-select";

export const RECURRING_TYPES = [
    {label: trans('general.page.space_contracts.recurring.monthly'), code: 'monthly'},
    {label: trans('general.page.space_contracts.recurring.yearly'), code: 'yearly'},
]

export default {
    name: "RecurringTypeSelect",
    props: {
        value: Object,
        type: String,
        name: String,
        placeholder: String,
        label: String,
        taggable: Boolean,
        background: String,
        simple: Boolean,
        disabled: Boolean
    },
    watch: {
        model: function (val) {
            this.$emit('change', val)
            this.$emit('input', val)
        },
        value:  function (val) {
            this.model = val;
        },
    },
    components: {
        vSelect
    },
    data() {
        return {
            model: null,
            options: RECURRING_TYPES
        }
    },
    methods: {

    },
    mounted() {
        if (this.value) {
            this.model = this.value
        }
    }
}
</script>

<style scoped>

</style>
